import { HTMLInputTypeAttribute } from "react";
import { ReactComponent as SearchIcon } from "../../assets/icons/form/search.svg";

interface Props {
  label?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  type?: HTMLInputTypeAttribute | undefined;
  inputClassName?: string;
  labelClassName?: string;
  placeholder?: string;
  error?: boolean;
  disabled?: boolean;
  hideIcon?: boolean;
}

export const SearchInput = ({
  label,
  value,
  onChange,
  type,
  inputClassName,
  labelClassName,
  placeholder,
  error,
  disabled,
  hideIcon,
  ...rest
}: Props) => {
  return (
    <div className="mb-4">
      <p
        className={`font-satoshi text-dark text-sm font-medium mb-3 ${labelClassName}`}
      >
        {label}
      </p>
      {hideIcon ? null : (
        <SearchIcon className="absolute top-[27px] left-10" />
      )}
      <input
        {...rest}
        disabled={disabled}
        value={value}
        onChange={onChange}
        type={type}
        className={`w-full h-[46px] px-4 ${hideIcon ? "" : "pl-10"} bg-sky-lighter border ${
          error ? "border-red-base" : "border-gray-border"
        } ${
          error ? "focus:border-red-base" : "focus:border-focused-border"
        } rounded font-satoshi text-base text-dark font-medium outline-none ${inputClassName}`}
        placeholder={placeholder}
      />
    </div>
  );
};
